import { useContext, useMemo } from "react";
import {
  ImageSearchSortBehaviour,
  SettingKey,
} from "@swagger/typescript-fetch-goflyer";
import { GoFlyerAdminContext } from "../contextApi/context";

export type ImageSearchSortMode = ImageSearchSortBehaviour | null;

export const useImageSearchSortMode = (): ImageSearchSortMode => {
  const { state } = useContext(GoFlyerAdminContext);

  return useMemo(() => {
    const userSettings = state.gfAdminUser?.settings || [];
    const setting = userSettings.find(
      (s) =>
        s?.setting?.settingKey === SettingKey.ImageSearchUsageSortBehaviour,
    );

    if (setting?.value != null) {
      return setting.value as ImageSearchSortBehaviour;
    }

    return null;
  }, [state.gfAdminUser?.settings]);
};
